import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/helpers/services/api.service';
import { HttpService } from 'src/app/helpers/services/http.service';
import { ToastresService } from 'src/app/helpers/services/toaster.service';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.css'],
})
export class InviteComponent {
  public user: any;
  public client: any;

  constructor(
    public activeModal: NgbActiveModal,
    public httpService: HttpService,
    private api: ApiService,
    private toastrsService: ToastresService,
  ) {}

  invite() {
    let apiUrl = this.client
      ? this.api.clients.invite(this.client.id)
      : this.api.users.invite(this.user.id);
    this.httpService.action(apiUrl, {}, 'inviteUserLoader').subscribe({
      next: (res: any) => {
        if (res.success) {
          this.activeModal.close();
          this.toastrsService.ShowSuccess(res.msg);
        } else {
          this.toastrsService.ShowError(res.msg);
        }
      },
    });
  }
}
